export default class BaseUserBetweenTime {

    startTime = '';
    endTime = '';

}